import { useState } from "react";

const navItems = [
  { label: "首页", href: "#top" },
  { label: "下载通道", href: "#channels" },
  { label: "本周热榜", href: "#hot" },
  { label: "最新版本", href: "#releases" },
  { label: "装机必备", href: "#featured" },
  { label: "下载百科", href: "#guide" },
];

export default function TopNav() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 border-b border-background-200/70 bg-background-50/95 backdrop-blur">
      <div className="mx-auto flex h-16 max-w-6xl items-center justify-between px-4 md:px-6">
        {/* 品牌 */}
        <a href="#top" className="flex items-center gap-2 whitespace-nowrap">
          <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
            <i className="ri-apps-2-fill text-lg"></i>
          </span>
          <span className="font-display text-lg font-bold leading-none text-foreground-950 md:text-xl">
            吃瓜软件
          </span>
        </a>

        {/* 桌面导航 */}
        <nav className="hidden items-center gap-1 lg:flex">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="whitespace-nowrap rounded-md px-3 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-primary-100 hover:text-primary-700"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="hidden items-center gap-3 lg:flex">
          <div className="flex h-10 w-56 items-center gap-2 rounded-md border border-background-200 bg-background-100 px-3 text-sm text-foreground-400">
            <i className="ri-search-line"></i>
            <span className="whitespace-nowrap">搜软件 / 版本</span>
          </div>
          <a
            href="#channels"
            className="flex h-10 items-center gap-1 whitespace-nowrap rounded-md bg-primary-500 px-4 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-download-2-line"></i>
            下载客户端
          </a>
        </div>

        {/* 移动端按钮 */}
        <button
          type="button"
          aria-label="菜单"
          onClick={() => setOpen((v) => !v)}
          className="flex h-10 w-10 items-center justify-center rounded-md text-foreground-800 lg:hidden"
        >
          <i className={open ? "ri-close-line text-2xl" : "ri-menu-line text-2xl"}></i>
        </button>
      </div>

      {/* 移动端面板 */}
      {open && (
        <div className="border-t border-background-200 bg-background-50 lg:hidden">
          <nav className="mx-auto flex max-w-6xl flex-col px-4 py-3 md:px-6">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setOpen(false)}
                className="rounded-md px-2 py-2.5 text-sm font-medium text-foreground-700 hover:bg-primary-100 hover:text-primary-700"
              >
                {item.label}
              </a>
            ))}
            <a
              href="#channels"
              onClick={() => setOpen(false)}
              className="mt-2 flex h-10 items-center justify-center gap-1 whitespace-nowrap rounded-md bg-primary-500 px-4 text-sm font-semibold text-background-50"
            >
              <i className="ri-download-2-line"></i>
              下载客户端
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}